// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { LoggedUserService } from './logged-user.service';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoggedUserResolverService implements Resolve<any> {
  constructor(private loggedUserService: LoggedUserService) {}
  resolve(): Observable<any> {
    return this.loggedUserService.loggedUser$.pipe(take(1));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/logged-user-resolver.service.ts